import { TRIP_STATUS_CODES } from './tripStatuses';

export const TRIP_IN_PROGRESS_STATUSES = Object.freeze([
  TRIP_STATUS_CODES.EN_ROUTE,
  TRIP_STATUS_CODES.ARRIVED_AT_PU,
  TRIP_STATUS_CODES.POB,
  // TRIP_STATUS_CODES.COMPLETED, // [TS-7470] Note: We no longer allow 'Completed' trips in 'Active Trips' page
]);
